/*
 * Author: Roger
 * File Created: Wednesday, 24-09-04 10:27 am
 * Last Modified: Wednesday, 24-09-11 05:05 pm, by Roger
 */
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { usePullToRefresh } from 'use-pull-to-refresh';
import { Box, CircularProgress } from '@mui/material';
const MAXIMUM_PULL_LENGTH = 240;
const REFRESH_THRESHOLD = 180;
const PageRefresh = () => {
  const {
    isReady,
    reload
  } = useRouter();
  const [standalone, setStandalone] = useState(false);
  const handleRefresh = () => {
    reload();
    return new Promise<void>(resolve => {
      setTimeout(() => {
        resolve();
      }, 3000);
    });
  };
  const {
    isRefreshing,
    pullPosition
  } = usePullToRefresh({
    onRefresh: handleRefresh,
    maximumPullLength: MAXIMUM_PULL_LENGTH,
    refreshThreshold: REFRESH_THRESHOLD,
    isDisabled: !isReady || !standalone
  });
  useEffect(() => {
    // 检查是否在 PWA 环境下
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) setStandalone(true);
  }, []);
  return <Box sx={{
    opacity: isRefreshing || pullPosition > 0 ? 1 : 0,
    display: isRefreshing || pullPosition >= REFRESH_THRESHOLD ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 0',
    color: '#FFF',
    background: '#111217',
    zIndex: isRefreshing || pullPosition > 0 ? 1 : 0
  }} data-sentry-element="Box" data-sentry-component="PageRefresh" data-sentry-source-file="index.tsx">
      <CircularProgress color="inherit" size={30} data-sentry-element="CircularProgress" data-sentry-source-file="index.tsx" />
    </Box>;
};
export default PageRefresh;